///composables/useLUserLang.js
export function useUserLang() {
  const supported = ["fr", "en", "es", "de", "it", "pt", "ru", "zh"];
  return computed(() => {
    const b = navigator.language.split("-")[0];
    return supported.includes(b) ? b : "fr";
  });
}
